import { useTranslation } from 'react-i18next';
import { QueryObserverOptions, useQuery } from 'react-query';
import { errorMessage } from '@api/messages';
import { downloadFile } from '../api';

type UseQueryOptionsKeys = Pick<QueryObserverOptions<number>, 'enabled'>;

export default function useDownloadFile(
  uploadId: number,
  options?: UseQueryOptionsKeys,
  zip?: boolean
) {
  const { t } = useTranslation();
  const { data, isFetching, refetch } = useQuery(
    ['downloadedFile', uploadId],
    () => downloadFile(uploadId, zip),
    {
      onError: error => {
        errorMessage({
          title: t('error.downloading.file'),
          message: null,
          error,
        });
      },
      ...options,
    }
  );

  return { file: data, isFetching, downloadFile: refetch };
}
